import "flatpickr/dist/themes/material_blue.css";
import React, { useState, useEffect } from "react";
import { post, get } from "../../../../helpers/api_helper";
import {
  GET_INDUS,
  ADD_INDUS,
  DELETE_INDUS
} from "../../../../helpers/url_api_constant";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Form,
  FormGroup,
  Card,
  Col,
  CardBody,
  Container,
  Input,
  Label,
  Modal,
  Row,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../../components/Custom/ConfirmDialog";
import MessageDialog, {
  useModalShowMessage,
} from "../../../../components/Custom/MessageDialog";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import { connect } from "react-redux";
//i18n
import { withTranslation } from "react-i18next";
import "../../../../assets/scss/datatables.scss";
import paginationFactory from "react-bootstrap-table2-paginator";
import OverButton from "../../../../components/Custom/Overbutton";
import Loading from "../../../../components/Custom/Loading";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import { getPermission } from "../../../../helpers/auth_helper";

function IndustrialEstate(props) {
  const searchObj = { ALIAS_NAME: "" };
  const createObj = { PID: "", ALIAS_NAME: "" };
  const permission = getPermission();
  const [readonly, setReadonly] = useState(false)
  const [pageAdd, setPageAdd] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [userActionType, setUserActionType] = useState("");
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);

  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();

  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />
        {permission.eOTR && (
          <>
            {/* <OverButton
              onClick={() => {
                setReadonly(false);
                onEdit(row);
                setUserActionType("(Edit)");
              }}
              color="info"
              icon="far fa-edit"
              label="Edit"
            /> */}
            <OverButton
              onClick={() => {
                onDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            />
          </>
        )}
      </div>
    );
  };
  // Action Button//

  const listData = [
    {
      Id: "1",
      Estate: "MTP",
    },

    {
      Id: "2",
      Estate: "RIL",
    },

    {
      Id: "3",
      Estate: "ESIE",
    },

    {
      Id: "4",
      Estate: "Suksawat",
    },
  ];

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      formatter: CountIndexRow,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
    {
      dataField: "ALIAS_NAME",
      text: "Industrial Estate",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      formatter: ButtonAction,
      headerAlign: "center",
      align: "left",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    //userEffect คือทำงานคล้ายๆ onInIt หมายถึงว่า พอมีการเรียกเข้า การใช้งานใน Component นี้จะทำอันนี้เป็นอันแรก//
    resetSearch();
    resetModel();
    // setModelDeviceList(listData);

    ///fixed header table
    let tableId = "indus-table";
    let scrollY = 232;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  //Function CURL 
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {

    setCreateModel(row);
    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    let bResult = true;
    if (createModel.ALIAS_NAME == "") {
      bResult = false;
    }
    return bResult;
  };

  // อันนี้เขียนแบบ async , await

  const fetchData = async (searchData) => {
    setIsLoading(true);
    try {
      let res = await post(GET_INDUS, searchData);
      // console.log(res);
      setModelDeviceList(res.data.EStateList);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  const saveData = async () => {
    // console.log(createModel);
    if (validateForm()) {
      setIsLoading(true);
      try {
        let res = await post(ADD_INDUS, createModel);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
          setPageAdd(false);
          fetchData(searchModel);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
    }
    setIsLoading(false);
  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_INDUS, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.resultDescription);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };

  function RenderList(prop) {
    // console.log(prop);
    return (
      <tr>
        <td className="text-center">{prop.indexlist}</td>
        <td className="text-center">{prop.data.Estate}</td>
        <td className="text-center">
          <Button
            className="me-1 text-center"
            onClick={() => setPageAdd(true)}
            color="info"
          >
            <i className="far fa-edit"></i>
            &nbsp; Edit
          </Button>
          <Button
            onClick={() => setModalDelete(true)}
            // className="btn-rounded"
            color="danger"
          >
            <i className="fas fa-trash-alt"></i>
            &nbsp; Delete
          </Button>
        </td>
      </tr>
    );
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Industrial Estate")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Master Data Setting
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Other
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Industrial Estate
                        </li>
                      </ol>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Col sm={15}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t(
                                  "Search Industrial Estate"
                                )}
                                onChange={(e) => setSearchModel(
                                  {
                                    ...searchModel,
                                    ALIAS_NAME: e.target.value
                                  })
                                }
                                value={searchModel.ALIAS_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>

                    <Col sm="7">
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          color="info"
                          className="mt-3"
                          onClick={() => onSearch()}
                        >
                          <i className="fas fa-search"></i>
                          &nbsp; Search
                        </Button>

                        <Button
                          color="warning"
                          className="mt-3 ms-2"
                          onClick={() => resetSearch()}
                        >
                          <i className="fas fa-redo-alt"></i>
                          &nbsp; Reset
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    {/* <Col sm="3"> */}
                    <div className="d-grid gap-0 d-md-block">
                      {permission.eOTR && (
                        <Button
                          onClick={() => onAdd()}
                          // className="btn-rounded"
                          color="success"
                          className="mt-4 mb-2"
                        >
                          <i className="fas fa-plus"></i>
                          &nbsp; Add
                        </Button>
                      )}
                    </div>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div>
                        {/* แบบเดิมใน div ใช้ ClassName นี้ className="table-responsive" */}
                        <BootstrapTable
                          id="indus-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          // defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalPageAdd */}
      <Modal size="lg" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Industrial Estate {userActionType}
          </h5>
        </div>
        <div className="modal-body">
          <CardBody>
            <AvForm className="needs-validation">
              <FormGroup className="row mb-3">
                <Label
                  className="col-sm-3 col-form-label text-center">
                  <span style={{ color: "#FF0E03" }}>* </span>
                  Industrial Estate
                </Label>
                <Col sm={8}>
                  <AvField
                    // style={{ border: "solid 1px #FFFFFF" }}
                    // readOnly={readonly}
                    disabled={readonly == true || userActionType == "(Edit)"}
                    name="ALIAS_NAME"
                    type="text"
                    errorMessage="Enter Industrial Estate"
                    className="form-control basicborder"
                    validate={{ required: { value: true } }}
                    onChange={(e) => setCreateModel(
                      {
                        ...createModel,
                        ALIAS_NAME: e.target.value
                      })
                    }
                    value={createModel.ALIAS_NAME}
                  />
                </Col>
              </FormGroup>
              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>

          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />

      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />

    </React.Fragment>
  );
}

IndustrialEstate.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ IndustrialEstate }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(IndustrialEstate));

// ตัวอย่าง ที่1 เรียกหน้าแบบง่ายๆ Comment 2021-09-13//
// const Meter = () => {
//   return (
//     <React.Fragment>
//     <div className="page-content">
//       <Container fluid>
//         <h2>write Html code or structure</h2>
//       </Container>
//     </div>
//     </React.Fragment>
//   )
// }
// export default Meter;
// ตัวอย่าง ที่1 เรียกหน้าแบบง่ายๆ Comment 2021-09-13//

// ตัวอย่าง Table แบบเก่า
{
  /* <Table className="table table-bordered mb-0">
<thead className="table-light">
  <tr>
    <th className="text-center">No.</th>
    <th className="text-center">Customer</th>
    <th className="text-center">Action</th>
  </tr>
</thead>
<tbody>
  {modelDeviceList.map((value, index) => (<RenderList key={index} data={value} indexlist={index + 1} />))}
</tbody>

</Table>
<br></br>
<nav aria-label="Page navigation example">
<ul className="pagination justify-content-end">
  <li className="page-item disabled">
    <a className="page-link">Previous</a>
  </li>
  <li className="page-item active">
    <a className="page-link">1</a>
  </li>
  <li className="page-item disabled">
    <a className="page-link">Next</a>
  </li>
</ul>
</nav> */
}
